module.exports = __webpack_public_path__ + "img/billing-cyan.a335f2d7.svg";